import React from "react";
import { PasswordInputProps } from "./types.ts";
import { StyledPasswordInput } from "./styles.ts";
import { Input } from "antd";

const PasswordInput: React.FC<PasswordInputProps> = ({
  ...props
}): JSX.Element => {
  return (
    <StyledPasswordInput>
      <Input.Password {...props} />
    </StyledPasswordInput>
  );
};

export default PasswordInput;
